// @TODO: <HEALTH2019>
(function () {
    App.controller('HealthInsuranceRefundFormCtrl', HealthInsuranceRefundFormCtrl);
    HealthInsuranceRefundFormCtrl.$inject = ['$scope', 'Config', 'healthInsuranceService', '$filter', 'HealthInsuranceComplaintRefundService', 'popUpService', '$state'];

    function HealthInsuranceRefundFormCtrl($scope, Config, healthInsuranceService, $filter, HealthInsuranceComplaintRefundService, popUpService, $state) {
        var self = this;
        self.selectedType = null;
        self.submitBusy = false;
        self.formTypes = [
            {id: 1, value: 'COMPLAINT', label: 'Reklamacja'},
            {id: 2, value: 'REFUND', label: 'Zwrot kosztów z powodu niedotrzymania terminów'},
            {id: 3, value: 'REFUND_70', label: 'Refundacja - zwrot 70% kosztów wizyty'},
        ];
        self.personsList = [];
        self.contactForms = [
            {id: 1, value: 'PHONE', label: 'Telefon'},
            {id: 2, value: 'EMAIL', label: 'E-mail'},
        ];
        self.motionsHistoryPageSize = 10;
        self.motionsHistoryPageCurrent = 0;
        self.motionsHistoryPagesNumber = 1;
        self.motionsHistory = [];

        self.formTypeChange = function (type) {
            self.selectedType = type;
        };

        self.formSubmit = function (value) {
            if (self.submitBusy) return;
            self.submitBusy = true;

            HealthInsuranceComplaintRefundService.sendMotion(value)
                .then(function () {
                    return popUpService.showPopUp({head: 'Dziękujemy!', content: 'Zgłoszenie zostało wysłane'})
                }, function () {
                    popUpService.showPopUp(({head: 'Wystąpił błąd', content: 'Prosimy spróbować ponownie'}));
                    return false;
                })
                .then(function (dialog) {
                    if (dialog) {
                        $state.reload();
                        return;
                    }
                    self.submitBusy = false;
                    self.motionsHistoryPageCurrent = 0;
                    self.motionsHistoryPagesNumber = 1;
                    fetchHistory();
                })
        };

        self.historyPageChanged = function (page) {
            self.motionsHistoryPageCurrent = page;
            fetchHistory();
        };

        initPage();
        fetchLastActive();
        fetchHistory();

        function initPage() {
            $scope.page = 'healthInsurance_refund_form';
            $scope.$emit('page', $scope.page);

            $scope.step = 'Reklamacja i refundacja';
            $scope.$emit('step', $scope.step);

            $scope.link = 'root.dashboard';
            $scope.$emit('link', $scope.link);
        }

        function fetchLastActive() {
            healthInsuranceService.getLastActiveDeclaration('TUZ')
                .then(function (success) {
                    if (success && success.data) self.personsList = $filter('preparePersonsList')(success.data);
                }, function (error) {
                });
        }

        function fetchHistory() {
            HealthInsuranceComplaintRefundService.fetchHistory(self.motionsHistoryPageCurrent, self.motionsHistoryPageSize)
                .then(function (success) {
                    if (success && success.data && success.data.data) self.motionsHistory = success.data.data;
                    if (success && success.data && success.data.pages) self.motionsHistoryPagesNumber = success.data.pages;
                }, function (error) {
                    self.motionsHistory = [];
                    self.motionsHistoryPagesNumber = 1;
                })
        }
    }
})();
// @TODO: </HEALTH2019>
